<template>
	<div class="grid-content">
		<div class="grid-content-title">费用明细</div>
		<div class="grid-content-search">
			<div class="line">
				<el-row :gutter="20">
					<el-col :span="9">
						<div class="box">
							<div class="label">明细查询：</div>
							<div class="input">
								<el-input v-model="query.keyword" placeholder="请输入描述关键字" class="input-with-select"
									size="small">
									<el-select v-model="query.type" slot="prepend" placeholder="请选择">
										<el-option label="增加" value="z"></el-option>
										<el-option label="减少" value="j"></el-option>
									</el-select>
								</el-input>
							</div>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="box">
							<div class="label">明细时间：</div>
							<div class="input">
								<el-date-picker v-model="query.date" type="daterange" range-separator="至"
									start-placeholder="开始日期" end-placeholder="结束日期" size="small" style="width: 100%;">
								</el-date-picker>
							</div>
						</div>
					</el-col>
					<el-col :span="7">
						<el-button type="primary" icon="el-icon-search" size="small" style="width: 6rem;">搜索</el-button>
						<el-button size="small" @click="query = {}">重置</el-button>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="grid-content-list cost">
			<div class="common-table">
				<table class="header">
					<colgroup>
						<col width="4%">
						<col width="7%">
						<col>
						<col width="11%">
						<col width="11%">
						<col width="10%">
						<col width="16%">
					</colgroup>
					<thead>
						<tr>
							<th>
								<el-checkbox></el-checkbox>
							</th>
							<th>类型</th>
							<th>描述</th>
							<th>变更前</th>
							<th>变更后</th>
							<th>状态</th>
							<th>时间</th>
						</tr>
					</thead>
				</table>
				<table class="body" v-loading="(loading && total>0)?true:false">
					<colgroup>
						<col width="4%">
						<col width="7%">
						<col>
						<col width="11%">
						<col width="11%">
						<col width="10%">
						<col width="16%">
					</colgroup>
					<thead>
						<template v-for="(item,index) in list">
							<tr class="separation-row">
								<td colspan="7"></td>
							</tr>
							<tr class="content-row">
								<td>
									<div style="display: flex;align-items: center;justify-content: center;">
										<el-checkbox></el-checkbox>
									</div>
								</td>
								<td>
									<div v-if="item.type=='减少'" class="type j">{{item.type}}</div>
									<div v-else-if="item.type=='增加'" class="type z">{{item.type}}</div>
									<!-- <div v-if="item.type=='增加'" class="type z">{{item.type}}</div> -->
									<div v-else class="type">-</div>
								</td>
								<td>
									<div class="text">{{item.text}}</div>
								</td>
								<td>
									<div class="amount">{{item.change_prev}}</div>
								</td>
								<td>
									<div class="amount">{{item.change_next}}</div>
								</td>
								<td>
									<div v-if="item.status == 0" class="status warning">
										<i class="el-icon-warning"></i>
										<span>待处理</span>
									</div>
									<div v-else-if="item.status == 1" class="status success">
										<i class="el-icon-success"></i>
										<span>已完成</span>
									</div>
									<div v-else-if="item.status == 2" class="status fail">
										<i class="el-icon-error"></i>
										<span>驳回</span>
									</div>
								</td>
								<td>
									<div class="time">{{item.time}}</div>
								</td>
							</tr>
						</template>
					</thead>
				</table>
			</div>
			<div v-if="loading && total<=0" style="min-height: 20rem;" v-loading="loading"></div>
			<div v-if="total>0" class="page">
				<el-pagination background layout="total, prev, pager, next" :current-page.sync="page" :total="total"
					@current-change="pageCost">
				</el-pagination>
			</div>
			<el-empty v-if="!loading && total<=0" style="height: 20rem;" description="暂无明细数据" :image-size="100">
			</el-empty>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: true,
				query: {},
				page: 1,
				total: 0,
				list: []
			};
		},
		created() {
			this.postCost();
		},
		methods: {
			pageCost(e) {
				this.page = e;
				this.postCost();
			},
			postCost() {
				const that = this;
				that.loading = true;
				that.$post('consoleCost', {
					page: that.page
				}).then(res => {
					setTimeout(function() {
						that.loading = false;
						that.total = res.data.total;
						that.list = res.data.list;
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.cost .common-table table.header tr th:nth-child(2) {
		text-align: center;
		padding: 0;
	}
	
	.cost .common-table table.header tr th:nth-child(3) {
		text-align: left;
		padding-left: 0.625rem;
	}
	
	.cost .common-table .text {
		padding: 0.625rem;
		font-size: 0.875rem;
	}

	.cost .common-table .type,
	.cost .common-table .amount,
	.cost .common-table .status,
	.cost .common-table .time {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #606266;
		font-size: 0.875rem;
	}

	.cost .common-table .type.j {
		color: red;
	}

	.cost .common-table .type.z {
		color: #07c160;
	}

	.cost .common-table .status {
		align-items: baseline !important;
	}

	.cost .common-table .status i {
		margin-right: 0.25rem;
	}

	.cost .common-table .status.warning {
		color: #E6A23C;
	}

	.cost .common-table .status.success {
		color: #07C160;
	}

	.cost .common-table .status.fail {
		color: #F56C6C;
	}
</style>
